import { Box, Dialog, DialogActions, TextField, DialogContent, DialogTitle, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { IoAdd } from 'react-icons/io5'
import * as RiskTypes from '../../Entities/RiskTypes'
import Heatmap from 'react-heatmap-grid'
import { useTranslation } from 'react-i18next'
import { Button } from '../../Common/ui/button'
import Textarea from '../../Common/ui/textArea'
import { useForm } from 'react-hook-form'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'

const QualitiativeRiskAssesment = ({ AllFormData, setAllFormData }) => {
    const { register, formState: { errors }, control } = useForm()
    const [ open, setOpen ] = useState(false)
    const { t } = useTranslation()
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ heatMapSelection, setheatMapSelection ] = useState(false)
    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData?.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])

    const handleBoxClick = (x, y) => {
        const mitigationRiskScore = RiskTypes.RISK_SCROING_DATA[y][x]?.value
        const mitigationImpact = x > 0 ? RiskTypes.RISK_SCROING_DATA[y][0]?.value : mitigationRiskScore
        const mitigationProbability = y < RiskTypes.RISK_SCROING_DATA.length - 1 ? RiskTypes.RISK_SCROING_DATA[RiskTypes.RISK_SCROING_DATA.length - 1][x]?.value : mitigationRiskScore

        setAllFormData({
            ...AllFormData,
            qualitativeRiskAssessment: {
                ...AllFormData?.qualitativeRiskAssessment,
                mitigationImpact: `${mitigationImpact}(${RiskTypes.yLabels[RiskTypes.IMPACT_VALUE.indexOf(mitigationImpact)]})`,
                mitigationProbability: `${mitigationProbability}(${RiskTypes.xLabels[RiskTypes.PROBABILITY_VALUE.indexOf(mitigationProbability)]})`,
                mitigationRiskScore: `${mitigationRiskScore}(${(mitigationRiskScore === RiskTypes.RISK_SCORE_ONE || mitigationRiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_CONTROLLED : (mitigationRiskScore === RiskTypes.RISK_SCORE_THREE || mitigationRiskScore === RiskTypes.RISK_SCORE_FOUR || mitigationRiskScore === RiskTypes.RISK_SCORE_FIVE || mitigationRiskScore === RiskTypes.RISK_SCORE_SIX) ? RiskTypes.RISK_LEVEL_LOW : (mitigationRiskScore === RiskTypes.RISK_SCORE_EIGHT || mitigationRiskScore === RiskTypes.RISK_SCORE_NINE) ? RiskTypes.RISK_LEVEL_MEDIUM : (mitigationRiskScore === RiskTypes.RISK_SCORE_TEN || mitigationRiskScore === RiskTypes.RISK_SCORE_TWELVE || mitigationRiskScore === RiskTypes.RISK_SCORE_FIFTEEN || mitigationRiskScore === RiskTypes.RISK_SCORE_SIXTEEN) ? RiskTypes.RISK_LEVEL_HIGH : (mitigationRiskScore === RiskTypes.RISK_SCORE_TWENTY || mitigationRiskScore === RiskTypes.RISK_SCORE_TWENTY_FIVE) && RiskTypes.RISK_LEVEL_EXTREME})`
            }
        })
    }

    const handleThreeCrossBoxClick = (x, y) => {
        const mitigationRiskScore = RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][x]?.value
        const mitigationImpact = x > 0 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][0]?.value : mitigationRiskScore
        const mitigationProbability = y < RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1][x]?.value : mitigationRiskScore

        setAllFormData({
            ...AllFormData,
            qualitativeRiskAssessment: {
                ...AllFormData?.qualitativeRiskAssessment,
                mitigationImpact: `${mitigationImpact}(${RiskTypes.Y_LABLES_THREE_CROSS[RiskTypes.IMPACT_VALUE_THREE_CROSS.indexOf(mitigationImpact)]})`,
                mitigationProbability: `${mitigationProbability}(${RiskTypes.X_LABLES_THREE_CROSS[RiskTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(mitigationProbability)]})`,
                mitigationRiskScore: `${mitigationRiskScore}(${(mitigationRiskScore === RiskTypes.RISK_SCORE_ONE || mitigationRiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_LOW : (mitigationRiskScore === RiskTypes.RISK_SCORE_THREE || mitigationRiskScore === RiskTypes.RISK_SCORE_FOUR) ? RiskTypes.RISK_LEVEL_MEDIUM : (mitigationRiskScore === RiskTypes.RISK_SCORE_SIX || mitigationRiskScore === RiskTypes.RISK_SCORE_NINE) && RiskTypes.RISK_LEVEL_EXTREME})`
            }
        })
    }

    const handleClose = () => {
        setOpen(false)
    }

    const onValueChange = (value, name) => {
        setAllFormData({ ...AllFormData, [name]: value })
    }

    return (
        <Typography>
            <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <Button variant="outline" onClick={() => { setOpen(true) }} className="m-3">
                        <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                            <IoAdd className="mr-2" size={15} /> {t('Score')}
                        </span>
                    </Button>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Impact')}</p>
                                :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.qualitativeRiskAssessment?.mitigationImpact || 0}</p>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Probability')}</p>
                                :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.qualitativeRiskAssessment?.mitigationProbability || 0}</p>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Risk Score')}</p>
                                :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.qualitativeRiskAssessment?.mitigationRiskScore || 0}</p>
                </Box>
                <Box gridColumn="span 6" >
                    <Textarea errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='probabilityJustification' label={t('Impact / Probability Justification')} register={register} placeholder={t('Enter Impact / Probability Justification')} type="text" value={AllFormData?.probabilityJustification} onValueChange={onValueChange} maxLength={250} />
                </Box>
                <Box gridColumn="span 6" >
                    <Textarea errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='riskScoreImpact' label={t('Impact of the Risk Score')} register={register} placeholder={t('Enter Impact of the Risk Score')} type="text" value={AllFormData?.riskScoreImpact} onValueChange={onValueChange} />
                </Box>
            </Box>
            <Dialog
                maxWidth
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ width: 1000 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--accent))' }}>{t('Choose Risk Score')}</div>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%' }}>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ width: '40%', padding: '30px' }}>
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <img src={'/Assets/Impact.svg'} style={{ height: '260px' }} alt="Impact" />
                                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        {heatMapSelection
                                            ? <Heatmap
                                                xLabels={RiskTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                yLabels={RiskTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                xLabelsLocation={'bottom'}
                                                xLabelWidth={50}
                                                data={RiskTypes.RISK_SCROING_DATA}
                                                squares
                                                height={50}
                                                onClick={(x, y) => {
                                                    handleBoxClick(x, y)
                                                    setSelectedBox({ x, y })
                                                }}
                                                                                                          title={(value) => value?.value ?? ""}

                                                cellStyle={(background, value, min, max, data, x, y) => ({
                                                    fontSize: '12.5px',
                                                    backgroundColor: value?.color,
                                                    color: 'hsl(var(--accent))',
                                                    border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid hsl(var(--score-box-highlight))' : 'none'
                                                })}
                                                cellRender={value => value && <div>{value.value}</div>}
                                            />
                                            : <Heatmap
                                                xLabels={RiskTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                yLabels={RiskTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                xLabelsLocation={'bottom'}
                                                xLabelWidth={50}
                                                data={RiskTypes.RISK_SCROING_DATA_THREE_CROSS}
                                                squares
                                                height={50}
                                                onClick={(x, y) => {
                                                    handleThreeCrossBoxClick(x, y)
                                                    setSelectedBox({ x, y })
                                                }}
                                                                                                          title={(value) => value?.value ?? ""}

                                                cellStyle={(background, value, min, max, data, x, y) => ({
                                                    fontSize: '12.5px',
                                                    backgroundColor: value?.color,
                                                    color: 'hsl(var(--accent))',
                                                    border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid hsl(var(--accent))fff6e' : 'none'
                                                })}
                                                cellRender={value => value && <div>{value.value}</div>}
                                            />}
                                    </div>
                                </div>
                                <img src={'/Assets/Probability.svg'} style={{ paddingLeft: '60px', marginLeft: '21px', paddingTop: '20px', marginBottom: '-40px' }} alt="Impact" />
                            </div>
                            <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Impact')} value={AllFormData?.qualitativeRiskAssessment?.mitigationImpact || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Probability')} value={AllFormData?.qualitativeRiskAssessment?.mitigationProbability || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Risk Score')} value={AllFormData?.qualitativeRiskAssessment?.mitigationRiskScore || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                </Box>
                                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        {heatMapSelection
                            ? <div style={{ paddingLeft: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                <div style={{ marginRight: 10, fontSize: '12px' }}>Risk Level</div>
                                {RiskTypes.RISK_RATINNG?.map((data, ind) => {
                                    return (
                                        <div style={{ width: 65, border: '0.5px solid black', color: 'hsl(var(--accent))', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                    )
                                })}
                            </div>
                            : <div style={{ paddingLeft: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                <div style={{ marginRight: 10, fontSize: '12px' }}>Risk Level</div>
                                {RiskTypes.RISK_RATINNG_THREE_CROSS?.map((data, ind) => {
                                    return (
                                        <div style={{ width: 65, border: '0.5px solid black', color: 'hsl(var(--accent))', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                    )
                                })}
                            </div>}
                        <div>
                            <Button className='ml-auto' onClick={handleClose} variant="outline">{t('Cancel')}</Button>
                            <Button className={'mr-5 ml-4'} onClick={() => handleClose()}>{t('Submit')}</Button>
                        </div>
                    </DialogActions>
                </Box>
            </Dialog>
        </Typography>
    )
}

export default QualitiativeRiskAssesment
